export default __webpack_public_path__ + "static/homepage_title_background_mobile-991b75ee8feb448552d6c8dd876bb4c7.png";